import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import { modalActionType } from 'utils/constants';

import actions from 'state/actions';
import utils from 'utils';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';

const AddUserRole = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const isEditingUserRows = useSelector(selectors.configurator.getIsEditingUserRows);
  const selectedCompanyId = useSelector(selectors.configurator.getSelectedCompanyForRoles);
  const companies = useSelector(selectors.configurator.getCompaniesForRoles);

  return (
    <CommonButton
      id="add-user-role-btn"
      scope="tertiary"
      value={t('AddUserRole')}
      customIcon="add"
      disabled={
        isEditingUserRows.length > 0 ||
        !utils.user.isActionByCompanyActive(
          actionType.ADD_USER_ROLE,
          companies.find((e) => e.idCompany === selectedCompanyId).name,
        )
      }
      action={() => dispatch(actions.modal.openModal(modalActionType.configurator.ADD_USER_MODAL))}
    />
  );
};

export default AddUserRole;
